
    <header class="topbar" [class.topbar--hub]="isHub">
      <div class="topbar__left">
        <button class="topbar__menu-btn" [class.topbar__menu-btn--visible]="sidebarCollapsed && !isHub" (click)="menuToggle.emit()">
          <span class="material-symbols-outlined">menu</span>
        </button>
        <div class="topbar__brand" routerLink="/dashboard">
          <img src="images/logo-light.svg" alt="PeruMoney" class="topbar__brand-img topbar__brand-img--light" />
          <img src="images/logo-panel.svg" alt="PeruMoney" class="topbar__brand-img topbar__brand-img--dark" />
        </div>
      </div>

      <!-- Search Bar -->
      <div class="topbar__search-wrap">
        <div class="topbar__search" [class.topbar__search--active]="searchActive()">
          <span class="material-symbols-outlined topbar__search-icon">search</span>
          <input
            #searchInput
            type="text"
            class="topbar__search-input"
            placeholder="Buscar módulos, reportes..."
            [ngModel]="searchQuery()"
            (ngModelChange)="searchQuery.set($event)"
            (focus)="searchActive.set(true)"
            (keydown.escape)="closeSearch()"
            (keydown.arrowdown)="moveSelection(1, $event)"
            (keydown.arrowup)="moveSelection(-1, $event)"
            (keydown.enter)="navigateSelected()"
          />
          @if (searchQuery()) {
            <button class="topbar__search-clear" (click)="clearSearch()">
              <span class="material-symbols-outlined" style="font-size: 18px;">close</span>
            </button>
          } @else {
            <kbd class="topbar__search-kbd">Ctrl+K</kbd>
          }
        </div>

        <!-- Search dropdown -->
        @if (searchActive() && searchResults().length > 0) {
          <div class="topbar__search-dropdown">
            <div class="topbar__search-dropdown-header">
              <span>Módulos Sugeridos</span>
            </div>
            <div class="topbar__search-dropdown-list">
              @for (result of searchResults(); track result.child.route; let i = $index) {
                <a
                  class="topbar__search-result"
                  [class.topbar__search-result--selected]="i === selectedIndex()"
                  [routerLink]="result.child.route"
                  (click)="closeSearch()"
                >
                  <span class="material-symbols-outlined topbar__search-result-icon">{{ result.child.icon }}</span>
                  <div class="topbar__search-result-info">
                    <span class="topbar__search-result-name" [innerHTML]="highlightMatch(result.child.label)"></span>
                    <span class="topbar__search-result-category">{{ result.group.label }}</span>
                  </div>
                </a>
              }
            </div>
          </div>
        }
      </div>

      <!-- Right side -->
      <div class="topbar__right">
        @if (!isHub) {
          <button class="topbar__back-btn" routerLink="/dashboard">
            <span class="material-symbols-outlined" style="font-size: 16px;">arrow_back</span>
            <span class="topbar__back-label">Volver al Panel</span>
          </button>
        }

        @if (tipoCambio()) {
          <div class="topbar__tc">
            <span class="topbar__tc-sunat">SUNAT</span>
            <div class="topbar__tc-row">
              <span class="topbar__tc-rate">
                <span class="topbar__tc-dir">C</span>
                {{ tipoCambio()!.compra | number:'1.3-3' }}
              </span>
              <span class="topbar__tc-sep">/</span>
              <span class="topbar__tc-rate">
                <span class="topbar__tc-dir">V</span>
                {{ tipoCambio()!.venta | number:'1.3-3' }}
              </span>
            </div>
          </div>
        }

        <button class="topbar__icon-btn" (click)="theme.toggle()">
          <span class="material-symbols-outlined">{{ theme.isDark() ? 'light_mode' : 'dark_mode' }}</span>
        </button>

        <button class="topbar__icon-btn">
          <span class="material-symbols-outlined">notifications</span>
        </button>

        <div class="topbar__user" (click)="menuOpen = !menuOpen">
          @if (auth.user()?.photo) {
            <img [src]="auth.user()!.photo" alt="" class="topbar__photo" />
          } @else {
            <p-avatar
              [label]="userInitials"
              shape="circle"
              styleClass="topbar__avatar"
            />
          }
        </div>

        <!-- User dropdown menu -->
        @if (menuOpen) {
          <div class="user-menu-backdrop" (click)="menuOpen = false"></div>
          <div class="user-menu">
            <div class="user-menu__header">
              @if (auth.user()?.photo) {
                <img [src]="auth.user()!.photo" alt="" class="user-menu__photo" />
              } @else {
                <div class="user-menu__avatar">{{ userInitials }}</div>
              }
              <div class="user-menu__info">
                <span class="user-menu__name">{{ auth.userDisplayName() }}</span>
                <span class="user-menu__role">{{ auth.user()?.role }}</span>
              </div>
            </div>
            <div class="user-menu__details">
              @if (auth.user()?.area_name) {
                <div class="user-menu__detail-row">
                  <span class="material-symbols-outlined" style="font-size: 16px;">work</span>
                  <span>{{ auth.user()!.area_name }}</span>
                </div>
              }
              @if (auth.user()?.agency_name) {
                <div class="user-menu__detail-row">
                  <span class="material-symbols-outlined" style="font-size: 16px;">business</span>
                  <span>{{ auth.user()!.agency_name }}</span>
                </div>
              }
            </div>
            <div class="user-menu__actions">
              <button class="user-menu__btn" (click)="goToProfile()">
                <span class="material-symbols-outlined" style="font-size: 18px;">person</span>
                <span>Mi Perfil</span>
              </button>
              <button class="user-menu__btn user-menu__btn--danger" (click)="logout()">
                <span class="material-symbols-outlined" style="font-size: 18px;">logout</span>
                <span>Cerrar Sesión</span>
              </button>
            </div>
          </div>
        }
      </div>
    </header>

    <!-- Search overlay backdrop -->
    @if (searchActive()) {
      <div class="topbar__overlay" (click)="closeSearch()"></div>
    }
